import { createSelector } from "reselect";
import { emailToName, valueOrEmpty, formatSingleRedPandaProject } from "../../../utils/helpers/text";
import {AppUserType} from "../../../Models/AppUserType";

export const getUser = (state: { user: AppUserType }) => state.user;

export const displayNameSelector = createSelector([getUser], (user) => user?.name || emailToName(user?.email) || "-");

export const projectDisplayText = createSelector(
  [
    getUser,
    (_state, redPandaProjects?: any[] | null, projectId?: string | null) => ({
      redPandaProjects,
      projectId,
    }),
  ],
  (user, { redPandaProjects, projectId }) => {
    const userProjects = Array.isArray(user?.redPandaProjects)
      ? user.redPandaProjects
      : [];

    const sourceProjects =
      Array.isArray(redPandaProjects) && redPandaProjects.length > 0
        ? redPandaProjects
        : [];

    if (Array.isArray(sourceProjects) && sourceProjects.length > 0) {
      const displayItems = sourceProjects
        .map((p) => {
          const themeNumber = p.themeNumber ?? p.theme_number;
          const projectId = p.projectId ?? p.project_id;
          if (!themeNumber) return "";
          const matched =
            Array.isArray(user?.redPandaProjects) &&
            user.redPandaProjects.find(
              (up) => up.projectId && up.projectId === projectId
            );

          return matched ? formatSingleRedPandaProject(matched) : themeNumber;
        })
        .filter(Boolean);

      if (displayItems.length > 0) {
        return displayItems.join(", ");
      }
    }

    if (projectId) {
      const p = userProjects.find(
        (p) =>
          p.projectId === projectId
      );

      if (!p) {
        return valueOrEmpty(projectId, false, "-");
      }

      const themeNumber = p.themeNumber ?? projectId;
      const shortName =
        p.projectShortName ??
        p.projectName ??
        projectId;

      if (themeNumber && shortName) {
        return `${themeNumber} - ${shortName}`;
      }
      return valueOrEmpty(projectId, false, "-");
    }

    return "-";
  }
);
